import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-remove-fs-confirm',
  templateUrl: './remove-fs-confirm.component.html',
  styleUrls: ['./remove-fs-confirm.component.scss']
})
export class RemoveFsConfirmComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<RemoveFsConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  noClicked() {
    this.dialogRef.close({status: 'cancelled'});
  }

  yesClicked() {
    this.dialogRef.close({status: 'confirmed'});
  }

}
